module.exports = __webpack_public_path__ + "static/media/mahimahi.ed2f52ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mahimahi.jpg
// module id = 203
// module chunks = 0